module.exports = __webpack_public_path__ + "static/media/Johan&Carma(6).73f3d343.jpg";